module.exports = __webpack_public_path__ + "static/media/pic_winie_03.771e6a94.png";